<form class="filter" #formElement [formGroup]="form">

    <mat-form-field class="medium-width margin-right-small">
        <input matInput autocomplete="off" formControlName="from" [matDatepicker]="pickerFrom" placeholder="Fecha cobro desde" required>
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
        <mat-error *ngIf="f.from.errors && f.from.errors.required">
            Ingrese la fecha desde
        </mat-error>
    </mat-form-field>
    <mat-form-field class="medium-width">
        <input matInput autocomplete="off" formControlName="to" [matDatepicker]="pickerTo" placeholder="Fecha cobro hasta" required>
        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>
        <mat-error *ngIf="f.to.errors && f.to.errors.required">
            Ingrese la fecha hasta
        </mat-error>
    </mat-form-field>

    <mat-form-field class="medium-width">
        <input type="text" matInput placeholder="Protocolo" formControlName="protocol">
    </mat-form-field>

    <mat-form-field class="medium-width">
        <input type="number" matInput placeholder="Nro cierre" formControlName="closeNumber">
    </mat-form-field>


    <mat-form-field class="medium-width">
        <input type="text" #doctor matInput placeholder="Medios de pago" formControlName="payment" [matAutocomplete]="autPayment">
        <mat-autocomplete #autPayment="matAutocomplete" [displayWith]="filterCompletePayments.displayFn">
            <mat-option *ngFor="let payment of filteredPaymentsOptions | async" [value]="payment">
                {{ payment.Name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="medium-width">
        <input type="text" #doctor matInput placeholder="Servicio" formControlName="service" [matAutocomplete]="autService">
        <mat-autocomplete #autService="matAutocomplete" [displayWith]="filterCompleteServices.displayFn">
            <mat-option *ngFor="let service of filteredServicesOptions | async" [value]="service">
                {{ service.Name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="medium-width">
        <input type="text" #doctor matInput placeholder="Puntos de venta" formControlName="invoicePoint" [matAutocomplete]="autInvoicePoint">
        <mat-autocomplete #autInvoicePoint="matAutocomplete" [displayWith]="filterCompleteInvoicePoints.displayFn">
            <mat-option *ngFor="let invoicePoint of filteredInvoicePointsOptions | async" [value]="invoicePoint">
                {{ invoicePoint.Name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
    <mat-checkbox formControlName="noControled">Sín controlar</mat-checkbox>
    <mat-checkbox formControlName="controled">Controlado</mat-checkbox>
    <mat-checkbox formControlName="observated">Observado</mat-checkbox>

</form>